import P from 'prop-types';
import { Api } from '../../../services/api';
import { useEffect, useState } from 'react';

export const InfoComponent = ({ idCarga }) => {
  const [carga, setCarga] = useState(null);

  const findCarga = async () => {
    try {
      const resp = await Api.get(`/carga/${idCarga}`);
      setCarga(resp.data);
    } catch (e) {
      setCarga(null);
    }
  };

  useEffect(() => {
    findCarga();
  }, []);

  return (
    <div>
      {carga && (
        <>
          <div className="row">
            <div className="col-6 mb-3">
              <label className="form-label">N° Carga</label>
              <input onChange={() => 0} type="text" className="form-control" value={carga.numero} />
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">Tipo</label>
              <input onChange={() => 0} type="text" className="form-control" value={carga.cod_tipo_documento} />
            </div>
            <div className="col-12 mb-3">
              <label className="form-label">Empresa</label>
              <input
                onChange={() => 0}
                type="text"
                className="form-control"
                value={
                  carga.cod_empresa == 1000
                    ? 'SR Embalagens Barretos'
                    : carga.cod_empresa == 1100
                    ? 'SR Embalagens Três Rios'
                    : carga.cod_empresa == 2000
                    ? 'Barreflex Barretos'
                    : carga.cod_empresa == 2100
                    ? 'Barreflex Sumaré'
                    : ''
                }
              />
            </div>
            <div className="col-12 mb-3">
              <label className="form-label">Cliente</label>
              <input onChange={() => 0} type="text" className="form-control" value={carga.nome_cliente} />
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">Transportadora</label>
              <input onChange={() => 0} type="text" className="form-control" value={carga.cod_transportador} />
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">Placa Veículo</label>
              <input onChange={() => 0} type="text" className="form-control" value={carga.placa} />
            </div>
            <div className="col-12 mb-3">
              <label className="form-label">Conferente</label>
              <input onChange={() => 0} type="text" className="form-control" value={carga.conferente} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

InfoComponent.propTypes = {
  idCarga: P.number,
};
